import React, { useState, useEffect } from "react";
import "./DashCard.css";
import { UserOutlined } from "@ant-design/icons";
import { Card } from 'antd';

const DashCard = ({ header, input, image, header_height, subheader_height, icon, extra_height, card_height, onClick, iconClassName }) => {
  const footer = icon 
  ? <img src={icon} alt="card-icon" style={{ height: '60px', width: '60px' }} className={iconClassName} /> 
  : <UserOutlined />;
  const text_header = header || "Default Text";
  const text_subheader = input;

  return (
    <div className={`card_container `}  >

      <Card className="user-card"  onClick={onClick}>
        <div className="card-body"  >
          <div className='card-content'>
            <div className="card-title">{text_header}</div>
            <div className="card-value">{text_subheader}</div>
          </div>
          <div className="card-icon">
            <span className='icon' >
              {footer}
            </span>
          </div>
        </div>
      </Card>



    </div>
  );
};

export default DashCard;
